<template>
  <svg
    width="16px"
    height="17px"
    viewBox="0 0 16 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>add</title>
    <desc>Created with Sketch.</desc>
    <g
      id="页面-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="INQUIRE"
        transform="translate(-1191.000000, -760.000000)"
        fill="currentColor"
        fill-rule="nonzero"
      >
        <g id="编组-6" transform="translate(1191.000000, 759.000000)">
          <path
            d="M8,1.5 C9.07974178,1.5 10.1274812,1.71160098 11.1141244,2.12892508 C12.0668446,2.5318867 12.922344,3.10863979 13.6568631,3.84315886 C14.3913853,4.57767794 14.9681384,5.43317108 15.3710969,6.38586621 C15.7884006,7.37251876 15.9999843,8.42024252 15.9999843,9.5 C15.9999843,10.5797386 15.7883833,11.6274781 15.3710781,12.6141212 C14.9681337,13.5668415 14.3913822,14.4223409 13.6568443,15.15686 C12.9222938,15.8913822 12.0668007,16.4681353 11.1141055,16.8710938 C10.1274498,17.288399 9.07970723,17.5 7.99997644,17.5 C6.92024566,17.5 5.87249049,17.288399 4.88584737,16.8710938 C3.93315851,16.4681494 3.07765909,15.8913791 2.34314002,15.15686 C1.60861781,14.4223095 1.03186472,13.5668164 0.62890624,12.6141212 C0.211600978,11.6274655 2.93098879e-14,10.5797418 2.93098879e-14,9.5 C2.93098879e-14,8.42024566 0.211600978,7.37250934 0.628925084,6.38584737 C1.0318867,5.43315851 1.60863979,4.57765909 2.34315886,3.84314002 C3.07767794,3.10861781 3.93317108,2.53186472 4.88586621,2.12890624 C5.8725219,1.71160098 6.92024566,1.5 8,1.5 Z M8.00001099,2.63450172 C4.21436559,2.63450172 1.13451742,5.71434989 1.13451742,9.49999529 C1.13451742,13.2856407 4.21436559,16.3654889 8.00001099,16.3654889 C11.7856564,16.3654889 14.8655046,13.2856407 14.8655046,9.49999529 C14.8655046,5.71434989 11.7856564,2.63450172 8.00001099,2.63450172 Z M7.99999215,4.92600838 C8.31575966,4.92600838 8.57174208,5.14999163 8.57174208,5.42628977 L8.57174208,5.42628977 L8.57174208,8.92825007 L12.0737024,8.92825007 C12.3500005,8.92825007 12.5739838,9.18423406 12.5739838,9.5 C12.5739838,9.81576751 12.3500005,10.0717499 12.0737024,10.0717499 L12.0737024,10.0717499 L8.57174208,10.0717499 L8.57174208,13.5737102 C8.57174208,13.8500084 8.31575809,14.0739916 7.99999215,14.0739916 C7.68422464,14.0739916 7.42824221,13.8500084 7.42824221,13.5737102 L7.42824221,13.5737102 L7.42824221,10.0717499 L3.92628192,10.0717499 C3.64998378,10.0717499 3.42600053,9.81576594 3.42600053,9.5 C3.42600053,9.18423249 3.64998378,8.92825007 3.92628192,8.92825007 L3.92628192,8.92825007 L7.42824221,8.92825007 L7.42824221,5.42628977 C7.42824221,5.14999163 7.68422621,4.92600838 7.99999215,4.92600838 Z"
            id="add"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Add'
});
</script>
